import React, { memo } from 'react';
import { Image } from 'react-native';
import { rem } from '../values';
import IconEmmaPNG from '../img/emma.png';
const IconEmmaWallet = ({ size = rem(44) }) => (<Image style={{ width: size, height: size }} source={IconEmmaPNG}/>);
export default memo(IconEmmaWallet);
